import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const CommunitySection = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Image with Dashboard Preview */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            {/* Main Dashboard Image */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-gray-100">
              <div className="aspect-video bg-gradient-to-br from-blue-50 to-purple-50 p-8">
                {/* Mock Dashboard UI */}
                <div className="bg-white rounded-2xl shadow-lg p-6 h-full">
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-red-400 rounded-full" />
                      <div className="flex-1">
                        <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
                        <div className="h-3 bg-gray-100 rounded w-24" />
                      </div>
                    </div>
                    
                    <div className="space-y-2 pt-4">
                      <div className="h-3 bg-gray-200 rounded w-full" />
                      <div className="h-3 bg-gray-200 rounded w-5/6" />
                      <div className="h-3 bg-gray-200 rounded w-4/6" />
                    </div>

                    <div className="flex space-x-2 pt-4">
                      <div className="h-8 bg-gray-100 rounded-lg flex-1" />
                      <div className="h-8 bg-gray-100 rounded-lg flex-1" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Comment Cards */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="absolute -right-6 top-10 bg-white rounded-xl shadow-xl p-4 max-w-[200px] hidden lg:block"
            >
              <div className="flex items-center space-x-2 mb-2">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-cyan-400 rounded-full" />
                <div className="text-xs font-semibold">Sarah M.</div>
              </div>
              <p className="text-xs text-gray-600">
                "Love this community! 💖"
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="absolute -left-6 bottom-10 bg-white rounded-xl shadow-xl p-4 max-w-[200px] hidden lg:block"
            >
              <div className="flex items-center space-x-2 mb-2">
                <div className="w-8 h-8 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full" />
                <div className="text-xs font-semibold">Alex K.</div>
              </div>
              <p className="text-xs text-gray-600">
                "Best decision ever! 🎉"
              </p>
            </motion.div>
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <h2 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
              Creators. Fans.
              <br />
              Nothing in between.
            </h2>

            <p className="text-xl text-gray-700 leading-relaxed">
              Patreon gives you a direct line of access to your fan community,
              with no ads or gatekeepers in the way.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Through real-time group chats, comments, DMs and even directly
              over email, you can connect more deeply and directly with your
              community here than anywhere else.
            </p>

            <div className="pt-4">
              <Link
                to="/product/online-community"
                className="inline-flex items-center px-8 py-4 text-lg font-semibold text-white rounded-full transition-all duration-200 hover:transform hover:-translate-y-0.5 hover:shadow-lg"
                style={{
                  backgroundColor: 'var(--patreon-btn-primary-bg)',
                }}
              >
                Build real community
                <svg
                  className="ml-2 w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
